import GeographicLevels from './GeographicLevels';

export default GeographicLevels;
